import React from 'react'
import { Upload, Quality } from "../interface/Upload"
import MediaView from './media/MediaView'

interface CalloutControllerProps {
  uploads: Upload[]
  show: boolean
  calloutDuration: number // milliseconds
  didFinishCycle: Function
  debug: boolean
  didFullyLoad: () => void
}

interface CalloutControllerState {
  currentIndex: number
  hasShown: boolean
  timers: any[]
  loadedCount: number
}

export default class CalloutController extends React.Component<CalloutControllerProps, CalloutControllerState> {
  finishTimer?: any

  constructor(props: CalloutControllerProps) {
    super(props)

    this.state = {
      currentIndex: 0,
      hasShown: false,
      timers: [],
      loadedCount: 0
    }
  }

  componentDidUpdate(prevProps: CalloutControllerProps, _prevState: CalloutControllerState) {
    if (this.props.show && !prevProps.show) {
      this.showCallouts()
    }
    if (JSON.stringify(this.props.uploads) !== JSON.stringify(prevProps.uploads)) {
      this.setState({ loadedCount: 0 })
    }
  }

  showCallouts() {
    let timers = []

    for (let i = 0; i < this.props.uploads.length; i++) {
      let timer = setTimeout(() => {
        this.setState({ currentIndex: i })
      }, i * this.props.calloutDuration)
      timers.push(timer)
    }

    this.setState({
      timers: timers,
      hasShown: true
    })
    this.finishTimer = setTimeout(() => {
      this.props.didFinishCycle()
    }, this.props.uploads.length * this.props.calloutDuration)
  }

  handleMediaViewReady(_uploadId: string) {
    this.setState({ loadedCount: this.state.loadedCount + 1 },
      () => {
        if (this.state.loadedCount >= this.props.uploads.length) {
          this.props.didFullyLoad()
        }
      })
  }

  render() {
    let animationClass = this.props.show ? "windmillShow" : "windmillHide"
    if (!this.state.hasShown) {
      animationClass = "hide"
    }

    return (
      <section id="calloutsContainer" className={animationClass}>
        {this.props.uploads.map((upload, index) => (
          <MediaView
            key={index}
            onScreen={index === this.state.currentIndex}
            upload={upload}
            className={"callout " + (index === this.state.currentIndex ? "windmillShow" : "windmillHide")}
            quality={Quality.HIGH}
            isReadyCallback={(uploadId) => this.handleMediaViewReady(uploadId)}
          />
        ))}
      </section>
    )
  }
}